import { setPostComponentData } from '../dataSetters'

export const mapPostComponentData = (post_components) =>
  post_components.map((post_component) => ({
    ...setPostComponentData(post_component),
  }))
